React = require 'react'
xtend = require 'xtend'

module.exports = (componentClass, baseProps = {}) -> (moreProps) ->
  React.createElement componentClass, xtend(baseProps, moreProps)



// WEBPACK FOOTER //
// ./app/scripts/lib/react/partial-component.coffee